'use strict';

/**
 * @author Maxim Seredkin
 * @param {*} $rootScope
 */
export default [
  '$rootScope',
  '$scope',
  '$security',
  'SpinnerService',
  '$location',
  'SignRestService',
  'UserRestService',
  'Notification',
  function (
    $rootScope,
    $scope,
    $security,
    SpinnerService,
    $location,
    SignRestService,
    UserRestService,
    Notification
  ) {

    $rootScope.$security = $security;
    $scope.spinnerService = SpinnerService;
    $scope.userOnline = 0;
    $scope.getStyle = getStyle;

    $rootScope.projectsToSignCount = 0;

    SignRestService.count(null, (data) => {
      $rootScope.projectsToSignCount = data._embedded || 0;
    });

    UserRestService.count(null, (data) => {
      $scope.userOnline = data._embedded || 0;
    });

    $scope.goBack = function() {
      window.history.back();
    };

    function getStyle() {
      if (
        /(projects\/\d+)|(dashboard)|(support-measure)|(invest-activity)|(primary-appeals)|(projects)|(sign)|(invest-plan)|(project-gchp)/.test(
          $location.$$path
        )
      ) {
        return true;
      }
      return false;
    }
    $rootScope.selectSettings = {
      smartButtonMaxItems: 3,
      styleActive: true,
      displayProp: 'name',
      idProperty: 'id',
      showCheckAll: false,
      showUncheckAll: false,
      checkBoxes: true,
    };

    $rootScope.selectTranslation = {
      checkAll: 'Выбрать все',
      uncheckAll: 'Удалить все',
      buttonDefaultText: 'Все',
    };

    $rootScope.referrer = '';
    $rootScope.isProjectPage = false;
    $rootScope.isFromProjectPage = false;

    $rootScope.getValue = function (path, data) {
      let tmpPath = path;
      let tmpData = data;

      if (path.indexOf('.') <= -1) {
        return tmpData[path.trim()];
      }

      path.split('.').forEach((current, index) => {
        if (!tmpData.hasOwnProperty(current)) return;

        tmpPath = current;
        if (
          !(
            tmpData[current] !== null &&
            typeof tmpData[current] === typeof [] &&
            index !== path.length - 1
          )
        ) {
          return;
        }

        tmpData = tmpData[current];
      });

      return tmpData[tmpPath.trim()];
    };

    $scope.$watch(
      function () {
        return $location.path();
      },
      function (newPath, oldPath) {

        if (/^\/projects$/.test(newPath) || /^\/project-gchp$/.test(newPath)) {
          UserRestService.notification(null, (data) => {
            const messages = data._embedded || [];
            messages.forEach((message) => {
              Notification.info({
                dismissOnTimeout: false,
                dismissOnClick: false,
                dismissButton: true,
                content: message,
              });
            });
          }); 
        }

        $rootScope.referrer = newPath;
        $rootScope.isProjectPage = /^\/projects\/\d+$/.test(
          $rootScope.referrer
        );
        $rootScope.isFromProjectPage = /^\/projects\/\d+$/.test(oldPath);

        if (!$rootScope.isProjectPage && !$rootScope.isFromProjectPage) {
          sessionStorage.removeItem('filters');
          sessionStorage.removeItem('localFilter');
          sessionStorage.removeItem('searching');
        }
      }
    );
  },
];
